import { render, staticRenderFns } from "./RwHistoryEdit.vue?vue&type=template&id=4e0f5698&scoped=true"
import script from "./RwHistoryEdit.vue?vue&type=script&lang=ts"
export * from "./RwHistoryEdit.vue?vue&type=script&lang=ts"
import style0 from "./RwHistoryEdit.vue?vue&type=style&index=0&id=4e0f5698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0f5698",
  null
  
)

export default component.exports